import {ErrorHandler, Inject, Injectable} from '@angular/core';

import {LogService} from '../services/log.service';


@Injectable()
export class ItdExceptionHandler implements ErrorHandler {
	constructor(
		// @Inject(LogService) log: LogService
		// @Inject(LogService) logService: LogService
		private log: LogService
	) {
		// this.log = logService;
	}


	// log: any;


	handleError(error: any): void {
		console.log('ItdExceptionHandler about to set needPageReLoad = true');
		console.log('this.log:');
		console.log(this.log);

		console.log('window[\'log\']');
		console.log(window['log']);



		this.log.exception(error);		// note - this will redirect after logging exception to db
		// this.log.needPageReLoad = true;
		// this.router.navigate(['common/profile']);



		// window.location.reload(true);
		// this.router.navigate(['profile']);


		// let theLog: any = window['log'];
		// if (theLog) {
		// 	theLog.needPageReLoad = true;
		// 	theLog.exception(error);
		// } else {
		// 	console.log('ItdExceptionHandler - No logger found');
		// }


	}
}

// https://medium.com/@amcdnl/global-error-handling-with-angular2-6b992bdfb59c#.9zf51xwnw
// https://www.bennadel.com/blog/3138-creating-a-custom-errorhandler-in-angular-2-rc-6.htm
// https://netbasal.com/angular-2-custom-exception-handler-1bcbc45c3230#.bjfz59y8p
// https://dpopescu.me/2016/10/21/catching-global-errors-in-angular-2/

// https://angular.io/docs/ts/latest/api/core/index/ErrorHandler-class.html
// http://stackoverflow.com/questions/38882969/change-in-angular2-rc5-exceptionhandler
// http://stackoverflow.com/a/38883195

// https://angular.io/docs/ts/latest/api/core/index/ErrorHandler-class.html
// http://stackoverflow.com/questions/39355296/custom-exceptionhandler-in-angular-2

// older rc4
// https://angular.io/docs/js/latest/api/core/index/ExceptionHandler-class.html
// http://stackoverflow.com/a/36351195



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/classes/itd-exception.ts